import React, { useEffect, useState } from 'react'
import teacher from "../imgs/teacher.png"
import { Button, Form, Row, Col } from "react-bootstrap"
import Fade from 'react-reveal/Fade';
import InputField from '../components/InputField';
import { useStateMachine } from "little-state-machine";
import { useForm } from "react-hook-form";
import updateAction from "../updateAction";
import * as yup from "yup";
import { Navigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup"
import { Helmet } from 'react-helmet'
import Success from '../components/Success';
import Failure from '../components/Failure';

const Tfinal = (props) => {
    function convetToTimestap(date) {
        if (date != undefined)
            return date.getTime() / 1000;
    }

    const { state, actions } = useStateMachine({ updateAction });
    const [go, setgo] = useState(false);
    const [msg, setmsg] = useState();
    const [GT, setGT] = useState("waiting");
    const [msgs,setmsgs]=useState([]);

    useEffect(() => {
        if (!state.dob) {
            setgo(true);
        }
    });
    useEffect(() => {
        getResponse();
    },[]);

    function getResponse() {
        let url = getURL();
        var requestOptions = {
            method: 'POST',
            redirect: 'follow',
        };

        fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => handleResponse(result))
            .catch(error => console.log('error', error));
    }

    function handleResponse(response) {
        var arr = [];
        var obj = JSON.parse(response);
        console.log("obj ", obj);
        setGT(obj.success);
        if(obj.warnings){
            for(let warn of obj.warnings){
                arr.push(warn["message"])
            }
            setmsgs(arr);
            console.log(msgs);
        }
        if (obj.success) {
            setmsg("Success")
        } else {
            setmsg("Falure");
        }

    }

    function getURL() {
        var saved = "1";
        var url = new URL("https://staging.cbistt.com/webservice/rest/server.php");
        url.searchParams.append('wstoken', "e08ec1597896ecd5f43ddd28da582265");
        url.searchParams.append('wsfunction', "auth_email_signup_user");
        url.searchParams.append('moodlewsrestformat', "json");
        url.searchParams.append('username', state.username);
        url.searchParams.append('password', state.password);
        url.searchParams.append('firstname', state.firstname);
        url.searchParams.append('lastname', state.surname);
        url.searchParams.append('email', state.email);
        url.searchParams.append('city', state.city);
        url.searchParams.append('customprofilefields[0][type]', "string");
        url.searchParams.append('customprofilefields[0][name]', "profile_field_Church");
        url.searchParams.append('customprofilefields[0][value]', state.church);
        url.searchParams.append('customprofilefields[1][type]', "string");
        url.searchParams.append('customprofilefields[1][name]', "profile_field_DOB");
        url.searchParams.append('customprofilefields[1][value]', convetToTimestap(state.dob));
        url.searchParams.append('customprofilefields[2][type]', "string");
        url.searchParams.append('customprofilefields[2][name]', "profile_field_Saved");
        url.searchParams.append('customprofilefields[2][value]', saved);
        url.searchParams.append('customprofilefields[3][type]', "string");
        url.searchParams.append('customprofilefields[3][name]', "profile_field_Sex");
        url.searchParams.append('customprofilefields[3][value]', state.Gender);
        url.searchParams.append('customprofilefields[4][type]', "string");
        url.searchParams.append('customprofilefields[4][name]', "profile_field_phone_no");
        url.searchParams.append('customprofilefields[4][value]', state.Phone);
        url.searchParams.append('customprofilefields[5][type]', "string");
        url.searchParams.append('customprofilefields[5][name]', "profile_field_Marital");
        url.searchParams.append('customprofilefields[5][value]', state.marry);

        url.searchParams.append('customprofilefields[21][type]', "string");
        url.searchParams.append('customprofilefields[21][name]', "profile_field_account_type");
        url.searchParams.append('customprofilefields[21][value]', "Teacher");
        return url.href;
    }





    return (

        <>
            <Helmet>
                <title>Registration</title>
            </Helmet>
            {go && (
                <Navigate to='/Tstep1' />
            )}
            <div className="bg"></div>
            <div className="bg bg2"></div>
            <div className="bg bg3"></div>
            {/* <div className="content"> */}

            <div className="container1">

                <div className="wrapper1">
                    <ul className="steps">
                        <li className="is-active">Step 4</li>
                    </ul>
                    <form className="form-wrapper1" >

                        <fieldset className="section is-active">
                            <Fade>
                                <>
                                    <h3>Welcome, {state.firstname}</h3>

                                    {msg}<br />
                                   
                                    {GT && (<>
                                        <Success /> <br />
                                        <p>You have successfully signed up please check your email address <b>{state.email}</b> to confirm your account</p>
                                    </>)
                                    }
                                    {!GT && (<>
                                        <Failure />
                                        {msgs.map(m => <p>{m}</p> )}
                                        <p><b>You might need to refresh the form and start over</b></p>
                                    </>
                                    )}
                                </>

                            </Fade>
                        </fieldset>

                    </form>
                </div>
            </div>


            {/* </div> */}
        </>
    )
}

// {"success":false,"warnings":[{"item":"username","itemid":0,"warningcode":"fielderror","message":"This username already exists, choose another"},{"item":"email","itemid":0,"warningcode":"fielderror","message":"This email address is already registered. Perhaps you created an account in the past? &lt;a href=&quot;https:\/\/cbistt.com\/login\/forgot_password.php&quot;&gt;Recover forgotten username or password&lt;\/a&gt;"}]}

export default Tfinal
